// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { css } from '@emotion/css';
import { Theme, useTheme } from '@mui/material';

import { useTimeline } from '@components/Timeline/Timeline/TimelineProvider';

// COMPONENT ---------------------------------------------------------------- //

const TimelineIndexHeader = () => {
  const theme = useTheme();
  const cls = useStyles(theme);

  const { header, headerSize, zIndex } = useTimeline();

  if (!headerSize) return null;
  return (
    <div className={cls.timelineIndexHeader} style={{ zIndex: zIndex + 7, flex: `0 0 ${headerSize}px` }}>
      {header}
    </div>
  );
};

// STYLES --------------------------------------------------------------------- //

const useStyles = (theme: Theme) => ({
  timelineIndexHeader: css`
    position: sticky;
    overflow: hidden;
    top: 0;
    background-color: ${theme.palette.background.paper};
    box-shadow: 0 0 16px #00000024;
  `,
});

// -------------------------------- EXPORT -------------------------------- //

export default TimelineIndexHeader;
